@if (isLoggedIn$ | async) {
  <sortapp-shell-navigation></sortapp-shell-navigation>
}
<p-toast autoZIndex [style]="{'white-space': 'pre-wrap','word-wrap': 'break-word ','-moz-white-space' : 'pre-wrap'}">
</p-toast>



